import { SVGAttributes } from "react";

export function Company2Icon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5625 16.5625V7.37504C16.5626 7.25573 16.5333 7.13822 16.4774 7.03283C16.4215 6.92744 16.3405 6.83738 16.2417 6.77057L10.4083 2.83307C10.2878 2.75156 10.1455 2.70801 10 2.70801C9.85446 2.70801 9.71225 2.75156 9.59167 2.83307L3.75833 6.77057C3.65948 6.83738 3.57854 6.92744 3.5226 7.03283C3.46666 7.13822 3.43744 7.25573 3.4375 7.37504V16.5625C3.4375 16.7559 3.51432 16.9414 3.65107 17.0781C3.78781 17.2149 3.97328 17.2917 4.16667 17.2917H15.8333C16.0267 17.2917 16.2122 17.2149 16.3489 17.0781C16.4857 16.9414 16.5625 16.7559 16.5625 16.5625ZM15.1042 15.8334H4.89583V7.76296L10 4.31765L15.1042 7.76296V15.8334Z"
        fill="#81939F"
      />
    </svg>
  );
}
